import { Form, Formik } from "formik";
import { observable } from "mobx";
import { inject, observer } from "mobx-react";
import { fromPromise, IPromiseBasedObservable } from "mobx-utils";
import React, { Component } from "react";
import { FormattedMessage, InjectedIntlProps, injectIntl } from "react-intl";
import { RouteComponentProps, withRouter } from "react-router";
import { compose } from "recompose";
import * as Yup from "yup";

import { PrimaryRedButton } from "nvent-web/components/Button";
import { PasswordField } from "nvent-web/components/form/PasswordField";
import { TextField } from "nvent-web/components/form/TextField";

import { LoginFlow } from "../../stores/LoginFlow";
import style from "./LoginForm.module.scss";

interface LoginFormValues {
  email: string;
  password: string;
}

export interface LoginFormInnerProps extends InjectedIntlProps, RouteComponentProps<{}> {
  login: LoginFlow;
}

export class LoginFormInner extends Component<LoginFormInnerProps> {
  schema = Yup.object({
    email: Yup.string()
      .required()
      .email(),
    password: Yup.string()
      .required()
      .password(),
  });

  @observable
  submitPromise?: IPromiseBasedObservable<void>;

  render() {
    const { login } = this.props;
    const isSubmitting = Boolean(this.submitPromise && this.submitPromise.state === "pending");

    const initialValues: LoginFormValues = {
      email: login.email,
      password: "",
    };

    return (
      <Formik initialValues={initialValues} onSubmit={this.submit} validationSchema={this.schema}>
        {() => (
          <Form noValidate={true}>
            <TextField
              type="email"
              name="email"
              label={<FormattedMessage id="form.email" />}
              className={{ inputContainer: style.inputContainer }}
            />

            <PasswordField
              name="password"
              label={<FormattedMessage id="form.password" />}
              className={{ inputContainer: style.inputContainer }}
            />

            <div className={style.submit}>
              <PrimaryRedButton
                type="submit"
                size="large"
                fixedWidth
                className={style.button}
                loading={isSubmitting}
                disabled={isSubmitting}
              >
                <FormattedMessage id="login.callToAction" />
              </PrimaryRedButton>
            </div>
          </Form>
        )}
      </Formik>
    );
  }

  private submit = ({ email, password }: LoginFormValues) => {
    this.submitPromise = fromPromise(this.props.login.startLogin(email, password));
  };
}

export const LoginForm = compose<LoginFormInnerProps, {}>(
  inject("login"),
  injectIntl,
  withRouter,
  observer
)(LoginFormInner);
LoginForm.displayName = "LoginForm";
